<template>
    <div class="name-array">
        <div class="title">
            {{name}}
        </div>
        <div class="array">
            <div class="grid"
                v-for="(item,idx) in line_data"
                :title="name + ':' + (idx+1)"
                :key = 'idx'
            >
                {{item}}
            </div>

        </div>
    </div>
    
</template>

<script>
export default {
    name:'NameArray',
    props:{
        name:String,
        data:Array,
    },
    computed:{
        line_data(){
            // console.log(data)
            return this.data.flat();
        }
    }
}
</script>

<style scoped lang="stylus">
.name-array
    color:white;
    margin:6px 0px;

    .title 
        display :inline;

    .array
        display:inline;

.array

.grid
    display:inline-block;
    width:30px;
    border:1px solid green;
    text-align :center;
</style>
